import { DraftError } from 'types/draftError';
import { DraftErrorType } from 'types/entityType';

export const missingAllData: DraftError = {
  errorType: DraftErrorType.MISSING_DATA,
  reason: 'Missing All Data',
};

export const invalidValidationError: DraftError = {
  errorType: DraftErrorType.VALIDATION_ERROR,
  reason: 'This is an invalid entity',
};

export const sspValidationError: DraftError = {
  errorType: DraftErrorType.SSP_VALIDATION_ERROR,
  reason: 'Cannot find entity',
};

export const draftErrors: DraftError[] = [
  {
    errorType: DraftErrorType.MISSING_DATA,
    reason: 'creative file format',
  },
  {
    errorType: DraftErrorType.MISSING_DATA,
    reason: 'dax product category',
  },
  {
    errorType: DraftErrorType.VALIDATION_ERROR,
    reason: 'Global Frame must have at least one Broadsign Frame',
  },
  {
    errorType: DraftErrorType.SSP_VALIDATION_ERROR,
    reason: 'ssp error because ssp was taking a day off',
  },
  {
    errorType: DraftErrorType.VALIDATION_ERROR,
    reason: 'No SpaceLinkedAsset found for space ID',
  },
  {
    errorType: DraftErrorType.SSP_VALIDATION_ERROR,
    reason: 'ssp data missing',
  },
  {
    errorType: DraftErrorType.MISSING_DATA,
    reason: 'venue type code',
  },
  {
    errorType: DraftErrorType.APPLICATION_ERROR,
    reason: 'server error',
  },
];
